import { apiClient } from '../../../shared/lib/http';
import { buildFullName, buildSurname } from '../../../shared/lib/personName';

export function createClient(payload) {
  return apiClient.post('/auth/registerClients', payload);
}

export async function updateClient(id, payload) {
  const { data } = await apiClient.put(`/client/${id}`, payload);
  return normalizeClient(data);
}

function normalizeMinor(minor) {
  return {
    name: minor?.name || '',
    surname: minor?.surname || '',
    secondSurname: minor?.secondSurname || '',
    fullName: minor?.fullName || buildFullName(minor),
    birthDate: minor?.birthDate || minor?.birthday || '',
  };
}

export function normalizeClient(client) {
  const minors = Array.isArray(client?.minors) ? client.minors.map(normalizeMinor) : [];

  return {
    id: client?.id || client?._id,
    name: client?.name || '',
    surname: client?.surname || '',
    secondSurname: client?.secondSurname || '',
    fullSurname: buildSurname(client),
    fullName: client?.fullName || buildFullName(client),
    email: client?.email || '',
    phone: client?.phone || '',
    birthday: client?.birthday || '',
    profileType: client?.profileType || null,
    minors,
  };
}

export function isGuardianClient(client) {
  if (!client) {
    return false;
  }

  if (client.profileType === 'VOUCHER_ONLY') {
    return false;
  }

  return Array.isArray(client.minors) && client.minors.length > 0;
}

export async function findClients(filters = {}) {
  const params = {};

  if (filters.name) {
    params.name = filters.name;
  }

  if (filters.phone) {
    params.phone = filters.phone;
  }

  const { data } = await apiClient.get('/client/findClient', {
    params,
  });

  return Array.isArray(data)
    ? data.map(normalizeClient).filter(isGuardianClient)
    : [];
}
